var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingMoreHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 10.0002C1.66699 9.07969 2.41318 8.3335 3.33366 8.3335C4.25413 8.3335 5.00033 9.07969 5.00033 10.0002C5.00033 10.9206 4.25413 11.6668 3.33366 11.6668C2.41318 11.6668 1.66699 10.9206 1.66699 10.0002ZM8.33366 10.0002C8.33366 9.07969 9.07985 8.3335 10.0003 8.3335C10.9208 8.3335 11.667 9.07969 11.667 10.0002C11.667 10.9206 10.9208 11.6668 10.0003 11.6668C9.07985 11.6668 8.33366 10.9206 8.33366 10.0002ZM15.0003 10.0002C15.0003 9.07969 15.7465 8.3335 16.667 8.3335C17.5875 8.3335 18.3337 9.07969 18.3337 10.0002C18.3337 10.9206 17.5875 11.6668 16.667 11.6668C15.7465 11.6668 15.0003 10.9206 15.0003 10.0002Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingMoreHorizontal);
export default __webpack_public_path__ + "static/media/onboarding-more-horizontal.ed363b014fde70a2de042a05bef56acb.svg";
export { ForwardRef as ReactComponent };